
import Vue from 'vue';
import { db } from "@/firebase";
import restCountriesMixin from "@/mixins/restCountriesMixin";

export default Vue.util.mergeOptions(restCountriesMixin, {
  methods: {

    async _convertSingleLanguageFormat(countryCode) {

      const {
        callingCodes,
        name: countryName,
        flag: countryFlag,
        languages: spokenLanguage,
      } = await this._getCountryByCode(countryCode);

      return {
        callingCodes,
        countryName,
        countryFlag,
        countryCode,
        nativeName: countryCode == 'PH' ? 'Tagalog' : `${spokenLanguage[0].nativeName.charAt(0).toUpperCase()}${spokenLanguage[0].nativeName.slice(1).toLowerCase()}`,
        foreignName: countryCode == 'PH' ? 'Tagalog' : `${spokenLanguage[0].name.charAt(0).toUpperCase()}${spokenLanguage[0].name.slice(1).toLowerCase()}`,
        id: Date.now(),
      };
    },
    async _updateLanguagesInFirebase(countryCode) {
      const convertedFormat = await this._convertSingleLanguageFormat(countryCode);
      return db.ref(`languages/${countryCode}/`).update(convertedFormat);
    },
    async _getCorrectEventLanguages() {
        const languageTypes = (await db.ref(`customers/${this.$customerId}/languageTypes`).once("value")).val();

        return Promise.all(languageTypes.map(async (countryCode, index) => {
          const {
            foreignName,
            countryFlag
          } = (await db.ref(`languages/${countryCode}`).once("value")).val();

          return {
            index,
            foreignName,
            countryCode,
            countryFlag
          }

        }))
    },
    async _getLanguageIndex() { 
      return (await db.ref(`users/${this.$userId}/languageTypesIndex`).once("value")).val();
    }
  }
});
